// extracted by mini-css-extract-plugin
export default {"headerSearch":"HeaderSearch_headerSearch__ilkZn","headerSearchPopup":"HeaderSearch_headerSearchPopup__2MbCi"};